import type { RoomTask } from 'src/common/interfaces/tasks';
import type { RoomDetailsData } from 'src/features/room/room.types';

export interface RoomFooterProps {
  tasks?: RoomTask[];
  roomCode: string;
  roomDetails?: RoomDetailsData;
  joinRoom: () => Promise<void>;
}

export enum TaskProgressStatus {
  IN_PROGRESS = 'in-progress',
  COMPLETED = 'completed',
  NOT_STARTED = 'not-started',
}
